import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ListResolverStoreEffects } from './list-resolver-store.effects';
import { listResolverStoreReducer } from './list-resolver-store.reducer';
import { ListResolverStoreService } from './list-resolver-store.service';
import {
  STATE_FEATURE_LIST_RESOLVER_STORE,
  getInitialListResolverStoreState,
} from './list-resolver-store.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ListResolverStoreEffects]),
    StoreModule.forFeature(
      STATE_FEATURE_LIST_RESOLVER_STORE,
      listResolverStoreReducer,
      { initialState: getInitialListResolverStoreState },
    ),
  ],
  providers: [ListResolverStoreService],
})
export class ListResolverStoreModule {}
